import { Icon, Tooltip } from "../../../components";

export function obterIconeStatus(status) {
  switch (status) {
    case "PENDENTE":
      return (
        <Tooltip title="Pendente" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#EA9D2B", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "ENVIADA":
      return (
        <Tooltip title="Enviada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#4FBB53", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "CANCELADA":
      return (
        <Tooltip title="Cancelada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#DC3545", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "ENCERRADA":
      return (
        <Tooltip title="Encerrada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#004780", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
  }
}
